import * as React from 'react';
import  './event.scss';
import {outlookEvent} from '../../Entity/OutlookEvent';
import Event from './event';


export interface IProps{
    data:outlookEvent;
    //UpdateMethod?; 
    phrases;
    extpropid;
    CreateOrCancelPreperationEvent;
    UpdateEvent;
    AcceptEvent;
    Getcrmdataforrecent;
    PrepareContactCRMReportUI;
    PrepareContactCRMSSOUI;
    GetCRMContactCompany;
    GetContactRelatedMails;
    GetOutlookemailAttachments;
    currentuseremail;
}
export default class EventCalItem extends React.Component<IProps>{
    constructor(props) {
        super(props);
      }
    public render() {
        return (

         <div className='Event'>      
              <div  className={['calitem','ellips'].join(' ')}>
                <Event 
                    data={this.props.data} 
                    phrases={this.props.phrases}  
                    extpropid={this.props.extpropid}
                    UpdateEvent={this.props.UpdateEvent}
                    CreateOrCancelPreperationEvent={this.props.CreateOrCancelPreperationEvent}
                    AcceptEvent={this.props.AcceptEvent}
                    Getcrmdataforrecent={this.props.Getcrmdataforrecent}
                    PrepareContactCRMReportUI={this.props.PrepareContactCRMReportUI}
                    PrepareContactCRMSSOUI={this.props.PrepareContactCRMSSOUI}
                    GetCRMContactCompany={this.props.GetCRMContactCompany}
                    GetContactRelatedMails={this.props.GetContactRelatedMails}
                    GetOutlookemailAttachments={this.props.GetOutlookemailAttachments}
                    currentuseremail={this.props.currentuseremail}
                />
              </div>
         </div>
        );
      }
}